import { Cart } from 'iconoir-react';
import React from 'react';

import { IconPropsInterface } from './Icon.types';

interface CartIconProps extends IconPropsInterface {
  color?: string;
  size?: string;
}

const CartIcon: React.FC<CartIconProps> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => {
  return <Cart width={size} height={size} color={color} {...rest} />;
};

CartIcon.displayName = 'CartIcon';

export default CartIcon;
